import { Inject, Injectable } from '@angular/core';
import { logError } from '@office-start/telemetry-service';

import { InstrumentationParam, InstrumentationService, KnownInstrumentationEvents } from '../../shared/instrumentation/instrumentation.service';
import { UpdateContentService } from '../../shared/services/update-content.service';
import { ContextService } from '../../shared/shared-context/context.service';
import { SERVICE_WORKER_ENABLED } from '../service-worker-enabled.injection-token';
import { ServiceWorkerRegistrationHandler } from './service-worker-registration-handlers.injection-token';

@Injectable()
export class ServiceWorkerUpdateContentHandlerService implements ServiceWorkerRegistrationHandler {
    constructor(
        @Inject(SERVICE_WORKER_ENABLED) private readonly serviceWorkerEnabled: boolean,
        private readonly updateContentService: UpdateContentService,
        private readonly contextService: ContextService,
        private readonly instrumentationService: InstrumentationService
    ) {
    }

    public handleRegistration(registration: ServiceWorkerRegistration): void | Promise<void> {
        if (!this.serviceWorkerEnabled || !this.contextService.sharedContext.serviceWorkerIntervalUpdateEnabled) {
            return;
        }

        this.updateContentService.getOrAddUpdateStream('serviceWorker', () => this.updateServiceWorkerRegistration(registration));
    }

    private async updateServiceWorkerRegistration(registration: ServiceWorkerRegistration): Promise<void> {
        try {
            await registration.update();
        } catch (error) {
            const errorObject = (error?.error || error);
            const message = `Error message: ${typeof errorObject === 'string' ? errorObject : errorObject?.message || 'not available'}`;
            const debugInfo = `installing:${registration?.installing}.onLine:${navigator?.onLine}.Call stack:${errorObject?.stack || 'not available'}`;
            logError({ eventName: 'ServiceWorkerUpdateContentServiceError', debugInfo, message });
            this.instrumentationService.logDebugCacheEvent(KnownInstrumentationEvents.ServiceWorkerUpdateContentServiceError, {
                [InstrumentationParam.Error]: message,
                [InstrumentationParam.DebugInfo]: debugInfo
            });
        }
    }
}
